import { render, staticRenderFns } from "./uodoComplaintsList.vue?vue&type=template&id=6b6c7ee9&scoped=true"
import script from "./uodoComplaintsList.vue?vue&type=script&lang=js"
export * from "./uodoComplaintsList.vue?vue&type=script&lang=js"
import style0 from "./uodoComplaintsList.vue?vue&type=style&index=0&id=6b6c7ee9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6c7ee9",
  null
  
)

export default component.exports